import { ImageBehaviour } from "@jti/core-components/components/ImageBehaviour";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

import styles from "./ReferralPersonalCode.module.scss";

export interface ReferralPersonalCodeIconPropsType {
  img: string;
  url: string;
  trackingName: string;
}

export const ReferralPersonalCodeIcon: React.FC<ReferralPersonalCodeIconPropsType> = ({ img, url, trackingName }) => {
  const dispatchGTMEvent = () => {
    dispatchTrackingEvent(TrackingEvents.TrackingSocialIconClick, { social_network: trackingName });
  };

  return (
    <a
      className={styles.icon}
      data-testid={"referral-personal-code-icon"}
      href={url}
      target={"_blank"}
      onClick={dispatchGTMEvent}
      rel="noreferrer"
    >
      <ImageBehaviour src={img} alt={"not found"} width={32} height={32} />
    </a>
  );
};
